"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelMenuItem = void 0;
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const components_1 = require("../../../components");
function isShown(item, search) {
    if (!search) {
        return 1;
    }
    const low = search.toLowerCase();
    if (item.text.toLowerCase().search(low) !== -1) {
        return 2;
    }
    for (const child of item.children) {
        const a = isShown(child, search);
        if (a > 0)
            return 1;
    }
    return 0;
}
const PanelMenuItem = function (props) {
    const { item, level, search, noFilter, homeFlag, defaultOnClick } = props;
    const [open, setOpen] = (0, react_1.useState)(false);
    const { icon, text, key, children, isMenu } = item;
    const active = isShown(item, search);
    if (active === 0 && !noFilter) {
        return null;
    }
    const clk = () => {
        if (!isMenu) {
            if (item.onClick) {
                item.onClick(item.key);
            }
            else {
                defaultOnClick?.(item.key);
            }
        }
    };
    const menuFunc = () => {
        if (isMenu) {
            setOpen(!open);
        }
        else {
            clk();
        }
    };
    const show = open || (search && search.length > 0);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Grid, { key: key, className: [
                `menu-item glx-no-select menu-item-level--${level || 0}`,
                'glx-default-text',
                [isMenu, 'menu-item--sub-menu'],
            ], onClick: menuFunc, flex: true, flexR: true, vCenter: true, gap: 2, flexSpaceB: true },
            react_1.default.createElement(components_1.Grid, { flex: true, flexR: true, className: "menu-item--content", vCenter: true, gap: 4 },
                react_1.default.createElement("div", { className: "menu-item--space" }),
                react_1.default.createElement("div", null, icon ? (0, react_icons_1.getIcon)(icon)({ size: 16 }) : null),
                react_1.default.createElement("div", null, text)),
            !homeFlag ? (react_1.default.createElement("div", { className: "menu-item--sub-menu-icon" }, isMenu ? (react_1.default.createElement("button", null, show ? (react_1.default.createElement(react_icons_1.IOChevronDown, { size: react_icons_1.ISize.SM })) : (react_1.default.createElement(react_icons_1.IOChevronForward, { size: react_icons_1.ISize.SM })))) : null)) : null),
        show
            ? children.map((ch) => (react_1.default.createElement(PanelMenuItem, { key: ch.key, item: ch, level: (level || 0) + 1, search: search, defaultOnClick: defaultOnClick, noFilter: noFilter || active === 2 })))
            : null));
};
exports.PanelMenuItem = PanelMenuItem;
PanelMenuItem.defaultProps = {
    level: 0,
    search: '',
    homeFlag: false,
    defaultOnClick: undefined,
    noFilter: undefined,
};
